import { CharlieQrCode } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../i18n/i18n';

type QrCodeCardProps = {
  qrData: string;
  appLogo?: string;
  appName: string;
};

function Step({ number, text }: { number: number; text: string }) {
  return (
    <div className="flex items-center gap-3">
      <span className="flex items-center justify-center size-6 rounded-full bg-primary/10 text-xs font-semibold text-primary">
        {number}
      </span>
      <span className="text-sm text-foreground">{text}</span>
    </div>
  );
}

export default function QrCodeCard({
  qrData,
  appLogo,
  appName,
}: QrCodeCardProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-6 rounded-xl border border-border p-6 w-full">
      <CharlieQrCode data={qrData} image={appLogo} />
      <div className="flex flex-col gap-4">
        <Step number={1} text={t('agentStart.step1', { appName })} />
        <Step number={2} text={t('agentStart.step2', { appName })} />
        <Step number={3} text={t('agentStart.step3', { appName })} />
      </div>
    </div>
  );
}
